export const SIGNALR_CONNECTION_LOST = 'SIGNALR_CONNECTION_LOST';
export const SIGNALR_CONNECTION_ESTABLISHED = 'SIGNALR_CONNECTION_ESTABLISHED';

export const SIGNALR_CONNECTION_RECONNECTING = 'SIGNALR_CONNECTION_RECONNECTING';
export const SIGNALR_CONNECTION_RECONNECTING_SUCCESS = 'SIGNALR_CONNECTION_RECONNECTING_SUCCESS';

export const SIGNALR_CONNECTING_ERROR = 'SIGNALR_CONNECTING_ERROR';
